import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Rarely-used screens live as small buttons inside their parent page instead of menu items (PHASE 2).
export function SubLinks({ links, testid = "sub-links" }) {
  const { user } = useAuth();
  const shown = links.filter((l) => (user?.permissions?.[l.to] ?? "-") !== "-");
  if (!shown.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {shown.map((l) => (
        <Link key={l.to} to={l.to} data-testid={`sub-link-${l.to}`}
          className="inline-flex items-center gap-1.5 rounded-xl border border-[#E3DED4] bg-white px-3 py-1.5 text-xs font-semibold text-[#45423C] hover:border-[#B9AE9A]">
          {l.icon && <l.icon className="h-3.5 w-3.5" />} {l.label}
        </Link>
      ))}
    </div>
  );
}
